import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { AiContentQueriesConfig } from './ai-content.queries';
export const AiContentApiClient = createApiClient(AiContentQueriesConfig);
//# sourceMappingURL=ai-content.api-client.js.map